// UserContext.jsx
import { createContext, useContext, useEffect, useState } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { doc, onSnapshot } from "firebase/firestore"
import { auth, db } from "../firebaseConfig"

const UserContext = createContext(null)

export function UserProvider({ children }) {
  const [authUser, setAuthUser] = useState(undefined) // undefined = loading
  const [userData, setUserData] = useState(null)

  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, (user) => {
      setAuthUser(user)
      if (!user) setUserData(null)
    })
    return () => unsubAuth()
  }, [])

  useEffect(() => {
    if (!authUser) return
    const ref = doc(db, "users", authUser.uid)
    const unsubSnap = onSnapshot(ref, (snap) => {
      if (snap.exists()) setUserData({ id: snap.id, ...snap.data() })
      else setUserData(null)
    })
    return () => unsubSnap()
  }, [authUser])

  return (
    <UserContext.Provider value={{ authUser, userData, loading: authUser === undefined }}>
      {children}
    </UserContext.Provider>
  )
}

export function useUser() {
  return useContext(UserContext)
}